<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Staff Load",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      staff_id: this.$route.params.staff,
      title: "Staff Load",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Staff Load",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "class.name",
          label: "Level",
          sortable: true,
        },
        {
          key: "subject.name",
          label: "Module",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        staff: this.$route.params.staff,
        class: "",
        subject: "",
      },
      deletedata: {
        staff: this.$route.params.staff,
        id: "",
      },
      classError: "",
      subjectError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("staff", ["AllStaff", "AllPositions", "SaveStatus", "Staff"]),
    ...mapGetters("classes", ["AllClasses", "AllSubjects", "GetClassSubjects"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Staff ? this.Staff.subjects.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Staff ? this.Staff.subjects.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStaff: "staff/fetchStaffDetails",
      FetchClasses: "classes/fetchClasses",
      FetchSubjects: "classes/fetchSubjects",
      AddLoad: "staff/addLoad",
      DeleteLoad: "staff/deleteLoad",
      FetchClassSubjects: "classes/fetchClassSubjects",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Staff ? this.Staff.subjects.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.classError = "";
      this.subjectError = "";
    },

    resetAddModal() {
      this.data.class = "";
      this.data.subject = "";
      this.resetError();
    },

    addLoad(modal) {
      if (this.data.subject == "") {
        this.subjectError = "Subject field can't be empty";
        return;
      } else {
        this.subjectError = "";
      }
      if (this.data.class == "") {
        this.classError = "Class Field is required";
        return;
      } else {
        this.classError = "";
      }
      this.modal = modal;
      this.AddLoad(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
    },
    deleteStaff(modal) {
      this.modal = modal;
      this.DeleteLoad(this.deletedata);
      this.closeModal(modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    fetchStreamsSubject(event) {
      this.fetchClassSub(event);
    },
    fetchClassSub(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class subjects
      this.FetchClassSubjects(classSelected);
    },
  },
  created() {
    this.FetchStaff(this.staff_id);
    this.FetchClasses();
    this.FetchSubjects();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_staff_load')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Load For {{ Staff ? Staff.name : "--" }}
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-staff-modal
                  class="btn btn-primary btn-sm float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_staff_load')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="form-group">
              <button
                @click="$router.go(-1)"
                class="btn btn-sm btn-warning mb-2"
              >
                <i class="fas fa-arrow-circle-left"></i> Go Back
              </button>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Staff ? Staff.subjects : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-staff-modal
                    @click="showDeleteModal(data)"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('delete_staff_load')
                      )
                    "
                    ><i class="fa fa-trash"></i
                  ></b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-staff-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_staff_load')
          )
        "
      >
        <template #modal-title> Add Load to Staff </template>
        <div class="form-group mb-2">
          <label>Level <span class="text-danger">*</span></label>
          <div class="input-group">
            <select
              required
              class="form-control"
              v-model="data.class"
              @change="fetchStreamsSubject($event)"
              name=""
              id=""
            >
              <option value="" selected disabled>Select Level</option>
              <option
                v-for="(classes, index) in AllClasses"
                :key="index"
                :value="classes.id"
              >
                {{ classes.name }}
              </option>
            </select>
          </div>
          <div class="text-danger" v-if="classError">
            <em>{{ classError }}</em>
          </div>
        </div>
        <div class="form-group mb-1">
          <label>Module <span class="text-danger">*</span></label>
          <div class="input-group">
            <select
              required
              class="form-control"
              v-model="data.subject"
              name=""
              id=""
            >
              <option value="" selected disabled v-if="SaveStatus">
                Fetching Modules...
              </option>
              <option value="" selected disabled v-else>Select Module</option>
              <option
                v-for="(subject, index) in GetClassSubjects"
                :key="index"
                :value="subject.id"
              >
                {{ subject.name }}
              </option>
            </select>
          </div>
          <div class="text-danger" v-if="subjectError">
            <em>{{ subjectError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-staff-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addLoad('add-staff-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>

      <!-- modal delete staff starts -->
      <b-modal
        id="delete-staff-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_load')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">Delete Staff Load</h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete this load from this staff member? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-staff-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-sm-danger"
            @click="deleteStaff('delete-staff-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
